<template>

<div class="mt-2">
    
    <div v-if='isReady' class="row">
        <div class="col-12">
            <div class="selected-item auction-item list-item shadow">
                <div class="list-info">
                    
                    <div class="list-header pt-3 pl-4 pr-4 pb-2">
                        <div class="row">
                            <div class="col-md-6 text-center text-md-left">
                                <h5 class="mb-0 mt-1">{{ auction.name }} {{ auction.last_name }}</h5>
                                <div class="d-flex justify-content-start">
                                    <user-rating :rating='auction.rating'></user-rating>                     
                                </div>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-12">
                                <p>Параметрите на Вашата оферта:</p>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                                    <span class="count-offers">
                                        Оферта: 
                                        <strong class="param-val"> {{ auction.cost }}лв. </strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                                    <span class="count-offers">
                                        Такса Видеа: 
                                        <strong class="param-val"> {{ videaTax() }}лв. </strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                                    <span class="count-offers">
                                        Сума за получаване: 
                                        <strong class="param-val"> {{ auction.cost - videaTax() }}лв. </strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="pr-info-item mb-2 p-3 d-flex align-items-center justify-content-between">
                                    <span class="count-offers">
                                        Срок на изпълнение: 
                                        <strong class="param-val"> {{ auction.time }} дни </strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>                        

                    <div class="list-body p-4">
                        <div class="row">
                            <div class="col-12">

                                <div v-if='delivery && delivery.finished != 1' >
                                    <phase-timer :end='delivery.end_date' :msg='timerMessage'></phase-timer>

                                    <div v-if='!isManager' class="alert alert-warning mt-3">
                                        Моля, постарай се да спазиш зададените срокове за изпълнение, за да може да получиш позитивен рейтинг от Видеа.
                                    </div>

                                    <div v-if='isManager' class="alert alert-info mt-3">
                                        Ти имаш достъп да наблюдаваш, оценяваш и отхвърляш работата на изпълнителят по този етап.
                                    </div>
                                </div>

                                <div v-if='delivery && finished' class="alert alert-info">
                                    Срокът за изпълнението е приключил.
                                </div>

                                <div v-if='!delivery' class="alert alert-info">
                                    Честито, ти спечели този етап на проекта. Ще получиш нотификация от администратор за стартиране на изпълнението.
                                </div>

                                <div v-if='delivery && delivery.finished == 1' class='alert alert-info'>
                                    Работата по този етап е завършена.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>

    <loading-div></loading-div>

    <div v-if='delivery' class="row mt-5">

        <div v-if='!isManager && delivery.finished == 0' class='col-12 mb-5'>
            <h3 class="fieldset-title text-left mb-2">Качване на изходни материали</h3>
            <dropzone :conf='dzConf' v-on:upload-success="addFile"></dropzone>
        </div>

        <loading-div v-if='!filesReady'></loading-div>

        <div class="col-12">

            <h3 class="fieldset-title text-left mb-2">Качени файлове</h3>
        </div>

        <div class="col-12 d-flex justify-content-center mb-5">
            <ul class="list-inline d-flex align-items-center files-view">
                <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                    <span class="icon icon-list"></span>
                </li>

                <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                    <span class="icon icon-grid"></span>
                </li>
            </ul>

            <div v-if='filesReady && !files.length' class="alert alert-info w-100">
                Все още не сте качили файлове към този етап. 
            </div>
        
            <div v-if='filesReady && files.length' id="files-holder" :class="{ 'grid-view' : grid, 'list-view' : !grid  }">

                <file-grid :files='files' 
                           :conf='fileConfig'
                           v-on:file-removed='fileRemoved'
                           :info='"Качен от вас"'></file-grid>

            </div>
        </div>

        <div class='col-12'>

            <h3 class="fieldset-title text-left mb-0">Комуникация с възложителя за конкретния етап</h3>
            <project-messages :conf='msgConfig'></project-messages>
        </div>

        <div v-if='delivery && delivery.finished == 0 && !isManager' class="col-12 mt-3">
            <h3 class="fieldset-title text-left mb-2">Край на етапа</h3>
            <div class='alert alert-info'>
                Когато си готов с работата по този етап, можеш да изполваш бутона по-долу за да предадеш на възложителя за преглед.
            </div>

            <button @click='finishDelivery' class='btn btn-success' v-if='!isLoading'>
                Работата по етапа е завършена
            </button>
            <loading-div v-if='isLoading'></loading-div>
        </div>

    </div>

            
    <div v-if='delivery && delivery.finished == 1 && delivery.status == 0' class='col-12 alert alert-warning mt-3'>
        Предложението е изпратено за преглед. Ще получиш информация от администратор на Видеа за това дали работата ти е приета, отхвърлена или се налага да направиш корекции по нея.
    </div>
  
    <div v-if='delivery && delivery.status == 1 && !$parent.access' class='col-12 alert alert-success mt-3'>
        Работата ти беше приета! Ти успешно завърши изпълнението на този етап. Благодарим ти!
    </div>

    <phase-decline-modal v-if='isReady && delivery && $parent.access === true && delivery.finished == 1 && delivery.status == 0' :delivery='delivery'  
                         v-on:approve='approveDelivery'
                         v-on:decline='declineDelivery'
                         v-on:correct='returnForCorrections'
                         :conf='dconf'></phase-decline-modal>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
            this.getFiles();
        },

        created() {
            if( typeof this.$parent.access == 'boolean' && this.$parent.access ) {
                //This component is opened for the managing person, overseeing the worker's job
                this.isManager = true;
            }
        },

        data() {

            return {
                
                timerMessage : 'Времето е изтекло',
                
                isManager : false,

                isReady     : false,
                isLoading   : false,
                auction     : false,
                delivery    : false,
                grid        : false,

                finished    : false,

                fileTypes : ['image/*'],

                files : [],
                filesReady : false,

                offerSent : false,

                dzConf : {
                    id      : 'udzp',
                    url     : '/system/phs:upf',
                    params  : {
                        p : this.$parent.projectPhase.id
                    }
                },

                dconf : {
                    canDecline : false
                }, 

                fileConfig : {
                    info        : "Качен от вас",
                    lightBoxId  : 'ufph',
                    download    : false,
                    remove      : true,
                    edit        : true,
                    removeUrl   : 'phs:rmf'
                },

                msgConfig : {
                    getUrl      : 'pmsg:gtpm',
                    getParams : {
                        pp : this.$parent.projectPhase.id
                    },
                    publishParams : {
                        project_phase_id : this.$parent.projectPhase.id,
                        project_id       : this.$parent.project.id
                    },
                    owner_id : this.$parent.project.user_id
                },
            }

        },

        methods : {

            videaTax() {
                var min = this.$store.state.coefs.mt;
                var per = Math.ceil( this.auction.cost * this.$store.state.coefs.tp / 100 );
                
                if( min > per ) {
                    return min;
                } else {
                    return per;
                }
            },

            getData() {
                
                var me = this;

                me.ajax.call('phs:gaw', { pp : this.$parent.projectPhase.id }, (r) => {

                    if( r.status == 'success' ) {

                        me.auction = r.data.a;
                        me.delivery = r.data.d;
                        me.initParams();
                    }

                    me.isReady = true;
                })

            },

            finishDelivery() {
                var me = this;

                if( !confirm('Сигурни ли сте, че искате да маркирате работата по етапа като завършена?') ) {
                    return;
                }

                me.isLoading = true;

                me.ajax.call('auc:fnd', { d : this.delivery.id }, (r) => {

                    me.isLoading = false;

                    if( r.status == 'success' ) {
                        me.delivery.finished = 1;
                        me.delivery = Object.assign( {}, me.delivery );
                    }

                })
            },

            getFiles() {
                var me = this;

                me.ajax.call('phs:gfs', { p : this.$parent.projectPhase.id }, (r) => {
                    
                    if( r.status == 'success' ) {
                        
                        me.files = r.data;

                    }

                    me.filesReady = true;

                })
            },


            addFile( f ) {
                this.files.push( f );

                 $.notify("Файлът беше качен успешно","success");
            },

            fileRemoved( i ) {

                this.files.splice(i,1);

                 $.notify("Файлът беше премахнат успешно","success");

            },

            initParams() {
                if( !this.delivery ) {
                    return;
                }

                var now = new Date();
                var endDate = new Date( this.delivery.end_date.split('-').join('/') );

                var diff = Math.ceil( ( endDate.getTime() - now.getTime() ) / 1000 );

                if( diff <= 0 ) {
                    this.finished = true;
                }

            },



            approveDelivery() {

                this.delivery = Object.assign( {}, this.delivery, { status : 1 } );
                $.notify('Усшешно одобрихте изпълнението на етапа.','success');

            },

            //Method 2
            declineDelivery() {
                        
                // this.delivery = false;
                // this.$parent.$parent.projectPhase = false;

                // bus.$emit('refresh-page');

                $.notify('Работата на изпълнителя беше отхвърлена.','success');

                setTimeout( () => {
                    
                    location.reload();

                }, 500);
          
            },

            returnForCorrections() {
            
                this.delivery = Object.assign( {}, this.delivery, { status : 0, finished : 0 } );
                $.notify('Работата беше върната за корекции.','success');


            }


        },

        components : {
            
        },

        watch : {

            'delivery.finished' : function( n, o ) {

                if( n == 1 ) {
                    this.fileConfig.remove = false;
                    this.filesReady = false;

                    var me = this;

                    this.$nextTick( () => {
                        me.filesReady = true;
                    })

                }

            }

        }

    }
</script>
